// extracted by mini-css-extract-plugin
module.exports = {"button":"indicador_button__3SJn3","filtro":"indicador_filtro__1Rp3-"};